<template>
  <div class="home">
    <b-carousel>
      <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
        <section
          :class="`bgcenter hero is-medium is-${carousel.color}`"
          :style="{'background-image': 'url('+ carousel.cover_src+')'}"
        >
          <div class="hero-body has-text-centered">
            <h1 class="title has-text-white is-size-3">{{carousel.text}}</h1>
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>

    <div class="columns is-mobile is-multiline">
      <div class="column is-full-desktop is-full-mobile is-full-tablet"></div>
      <div class="column is-full-desktop is-full-mobile is-full-tablet">
        <GuanggaoCard adname="广告1"></GuanggaoCard>
      </div>
      <div class="column is-full-mobile is-half-desktop is-full-mobile is-full-tablet">
        <CategoryCard category_name="目录_A" :book_n="n_book_per_category"></CategoryCard>
      </div>
      <div class="column is-full-mobile is-half-desktop is-full-mobile is-full-tablet">
        <CategoryCard category_name="目录_B" :book_n="n_book_per_category"></CategoryCard>
      </div>

      <div class="column is-full-desktop is-full-mobile is-full-tablet">
        <GuanggaoCard adname="广告1"></GuanggaoCard>
      </div>
      <div class="column is-full-mobile is-half-desktop is-full-mobile is-full-tablet">
        <CategoryCard category_name="目录_C" :book_n="n_book_per_category"></CategoryCard>
      </div>
      <div class="column is-full-mobile is-half-desktop is-full-mobile is-full-tablet">
        <CategoryCard category_name="目录_D" :book_n="n_book_per_category"></CategoryCard>
      </div>
    </div>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>小黄书</strong> by
          <a href="https://jgthms.com">xiaohuangshu</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import CategoryCard from "@/components/CategoryCard.vue";
import GuanggaoCard from "@/components/AdCard.vue";
import BasicAPIs from "@/api/apis";
export default {
  name: "Home",
  components: {
    CategoryCard,
    GuanggaoCard
  },
  data() {
    return {
      category_info: null,
      carousels: [],
      n_book_per_category: 5
    };
  },
  created() {
    let vm = this;
    BasicAPIs.getCategory("推荐")
      .then(res => {
        vm.category_info = res.data.msg.category_info;
        return res.data.msg.category_info;
      })
      .then(category_info => {
        if (category_info) {
          let carousels = [];
          for (let i = 0; i < category_info.length; i++) {
            vm.getbookinfo(i, category_info[i]);
            carousels.push({
              text: "Loading...",
              color: "primary"
            });
          }
          vm.carousels = carousels;
        }
      });
  },
  methods: {
    getbookinfo(i, book_id) {
      let vm = this;
      BasicAPIs.getBooksummary(book_id).then(res => {
        let book = res.data.msg.book;
        vm.carousels[i].text = book.title;
        vm.carousels[i].cover_src = book.cover_src;
        vm.carousels[i].book_id = book_id;
        // console.log("获取" + book_id + book.title);
      });
    }
  }
};
</script>
<style scoped>
.bgcenter {
  background-position: center;
  background-size: cover;
}
</style>